import React from 'react';
import { IoClose } from 'react-icons/io5';
import { FaUser, FaKey, FaCalendarAlt, FaHotel } from 'react-icons/fa';
import { BsReceipt } from 'react-icons/bs';

const CheckoutConfirmationModal = ({ reservation, onClose, onConfirm }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-full max-w-lg p-6 bg-white rounded-lg shadow-2xl">
        {/* Close Icon */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-red-500 hover:text-red-700  font-semibold transition-colors"
          aria-label="Close"
        >
          <IoClose size={28} />
        </button>

        {/* Title */}
        <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          Guest Checkout Confirmation
        </h3>

        <h2 className="text-lg font-bold text-gray-500 mb-4">Reservation Details</h2>

        {/* Enhanced Reservation Details */}
        <div className="mb-6">
          {/* First Row - Guest and Booking ID */}
          <div className="flex justify-between mb-4">
            {/* Guest Info */}
            <div className="flex items-center w-1/2 pr-2">
              <div className="bg-blue-100 p-2 rounded-lg mr-3">
                <FaUser className="text-blue-600" />
              </div>
              <div>
                <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                  Guest
                </h4>
                <p className="text-gray-800 font-medium">
                  {reservation.firstname} {reservation.lastname}
                </p>
              </div>
            </div>

            {/* Booking ID */}
            <div className="flex items-center w-1/2 pl-2">
              <div className="bg-purple-100 p-2 rounded-lg mr-3">
                <BsReceipt className="text-purple-600" />
              </div>
              <div>
                <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                  Reservation Number
                </h4>
                <p className="text-gray-800 font-medium">{reservation.orderid}</p>
              </div>
            </div>
          </div>

          {/* Second Row - Room and Checkout Date */}
          <div className="flex justify-between">
            {/* Room Number */}
            <div className="flex items-center w-1/2 pr-2">
              <div className="bg-green-100 p-2 rounded-lg mr-3">
                <FaHotel className="text-green-600" />
              </div>
              <div>
                <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                  Room Number
                </h4>
                <p className="text-gray-800 font-medium">{reservation.roomnumber || 'N/A'}</p>
              </div>
            </div>

            {/* Checkout Date */}
            <div className="flex items-center w-1/2 pl-2">
              <div className="bg-amber-100 p-2 rounded-lg mr-3">
                <FaCalendarAlt className="text-amber-600" />
              </div>
              <div>
                <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                  Check-Out
                </h4>
                <p className="text-gray-800 font-medium">{reservation.checkoutdate}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 border-l-4 border-blue-400 p-3 mb-6 rounded">
          <div className="flex items-start">
            <div className="flex-shrink-0 pt-0.5">
              <svg
                className="h-5 w-5 text-blue-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2h-1V9z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-1">
              <p className="text-sm text-blue-700">
                <strong>Important:</strong> Please inspect the room for damages, note any issues and
                collect keys from the guest before confirming checkout.
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-2">
          <button
            onClick={onClose}
            className="px-5 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(reservation.bookingid)}
            className="px-5 py-2.5 text-sm font-medium text-white bg-black rounded-lg hover:bg-gray-800 transition-all shadow-sm"
          >
            Confirm Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutConfirmationModal;
